// MobileSubNavbar.jsx
import { useRef, useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import "./SubNavbar.css";

const SubNavbar = ({ subMenuItems }) => {
  const scrollRef = useRef(null);
  const location = useLocation();
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(true);

  const updateArrows = () => {
    const el = scrollRef.current;
    if (!el) return;
    setShowLeft(el.scrollLeft > 5);
    setShowRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 5);
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    updateArrows();
    el.addEventListener("scroll", updateArrows);
    return () => el.removeEventListener("scroll", updateArrows);
  }, []);

  // Auto-scroll active pill into view on route change
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    const activePill = el.querySelector(".sub-nav-pill.sub-nav-active");
    activePill?.scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "nearest",
    });
  }, [location.pathname]);

  const scroll = (dir) => {
    scrollRef.current?.scrollBy({
      left: dir * 120,
      behavior: "smooth",
    });
  };

  return (
    <div className="sub-navbar-mobile">
      <button
        className={`sub-nav-arrow ${!showLeft ? "sub-nav-arrow-hidden" : ""}`}
        onClick={() => scroll(-1)}
        aria-label="Scroll left"
      >
        <FiChevronLeft size={16} />
      </button>

      <div className="sub-nav-scroll" ref={scrollRef}>
        {subMenuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;

          return (
            <Link
              key={item.item}
              to={item.path}
              className={`sub-nav-pill ${isActive ? "sub-nav-active" : ""}`}
            >
              <Icon size={14} />
              <span>{item.mobileLabel || item.item}</span>
            </Link>
          );
        })}
      </div>

      <button
        className={`sub-nav-arrow ${!showRight ? "sub-nav-arrow-hidden" : ""}`}
        onClick={() => scroll(1)}
        aria-label="Scroll right"
      >
        <FiChevronRight size={16} />
      </button>
    </div>
  );
};

export default SubNavbar;
